import React from 'react';
import { Switch as ToggleSwitch } from '@mui/material';
import { FormControlLabel, FormGroup } from '@mui/material';
import styled from '@emotion/styled';

const AntSwitch = styled(ToggleSwitch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    margin: '0 5px',

    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor:
                    theme.palette.mode === 'dark' ? '#177ddc' : '#0061DB',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 12,
        height: 12,
        borderRadius: 6,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor:
            theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : '#E5E6EB',
        boxSizing: 'border-box',
    },
}));

export const Switch = ({
    size = 'medium',
    label,
    labelPlacement = 'end',
    onClick,
    checked,
}) => {
    return (
        <FormGroup>
            <FormControlLabel
                control={<AntSwitch checked={checked} />}
                label={label}
                size={size}
                labelPlacement={labelPlacement}
                onClick={onClick}
                sx={{ margin: 0 }} // Remove the margin
            />
        </FormGroup>
    );
};
